import { create } from "zustand"
const useTopNavStore = create((set) => ({
    isMenuOpen : false,
    
    openAllMenu : () => set(() => ({isMenuOpen:true})),
    closeAllMenu: () => set(() => ({ isMenuOpen: false})),
}));

export default useTopNavStore;